import AdminDashboardPage from './AdminDashboardPage';
export default AdminDashboardPage;
